import { useContext } from 'react';

import { TokenContext } from '../providers/WebAuthProvider';

import { TokenProviderType } from '../providers/WebAuthProvider/types';

export const useToken = (): TokenProviderType => useContext(TokenContext);
